(() => {
  const fixedHolidays = new Set(['01-01','01-06','05-01','08-15','10-12','11-01','12-06','12-08','12-25']);
  const pad = value => String(value).padStart(2, '0');
  const dateKey = date => `${date.getUTCFullYear()}-${pad(date.getUTCMonth() + 1)}-${pad(date.getUTCDate())}`;
  function goodFriday(year) {
    const a = year % 19, b = Math.floor(year / 100), c = year % 100;
    const d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31);
    const day = (h + l - 7 * m + 114) % 31 + 1;
    return dateKey(new Date(Date.UTC(year, month - 1, day - 2)));
  }
  function addWorkingDays(start, count) {
    const date = new Date(start);
    while (count > 0) {
      date.setUTCDate(date.getUTCDate() + 1);
      const key = dateKey(date);
      if (![0,6].includes(date.getUTCDay()) && !fixedHolidays.has(key.slice(5)) && key !== goodFriday(date.getUTCFullYear())) count--;
    }
    return date;
  }
  if (customElements.get('ls-delivery-estimate')) return;
  customElements.define('ls-delivery-estimate', class extends HTMLElement {
    connectedCallback() {
      this.refresh = this.refresh.bind(this);
      this.root = this.closest('product-info');
      this.observer = new MutationObserver(() => this.updateAvailability());
      if (this.root) this.observer.observe(this.root, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled'] });
      document.addEventListener('visibilitychange', this.refresh);
      window.addEventListener('pageshow', this.refresh);
      this.timer = setInterval(this.refresh, 60000);
      this.refresh();
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.observer?.disconnect();
      document.removeEventListener('visibilitychange', this.refresh);
      window.removeEventListener('pageshow', this.refresh);
    }
    updateAvailability() {
      const button = this.root?.querySelector('product-form [name="add"]');
      if (button) this.hidden = button.disabled;
    }
    refresh() {
      const parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Madrid', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
      const values = Object.fromEntries(parts.map(part => [part.type, part.value]));
      const today = new Date(Date.UTC(Number(values.year), Number(values.month) - 1, Number(values.day)));
      const key = dateKey(today);
      if (key !== this.currentDay) {
        const format = new Intl.DateTimeFormat(document.documentElement.lang || 'es', { timeZone: 'UTC', day: 'numeric', month: 'short' });
        const start = format.format(addWorkingDays(today, 10));
        const end = format.format(addWorkingDays(today, 20));
        this.querySelector('[data-delivery-dates]').textContent = this.dataset.label.replace('[start]', start).replace('[end]', end);
        this.currentDay = key;
      }
      this.updateAvailability();
    }
  });
})();
